const en = {
  "app.webcheckin.title": "Web Check-in",
  "app.webcheckin.no_booking": "Booking No.",
  "app.webcheckin.customer": "Customer",
  "app.webcheckin.channel": "Booking Channel",
  "app.webcheckin.reservation_detail": "Reservation Detail",
  "app.webcheckin.experiences": "Experiences",
  "app.webcheckin.meal_plan": "Meal plan",
  "app.webcheckin.arrive.date": "Arrive",
  "app.webcheckin.departure.date": "Departure",
  "app.webcheckin.nights_quantity": "{nights} nights",
  "app.webcheckin.reserved rooms": "Reserved Rooms",
  "app.webcheckin.intro_info": "Now you can check in quickly and hassle-free.",
  "app.webcheckin.view_guest": "View registered guests",
  "app.webcheckin.max_accommodation": "Up to {max} guests",
  "app.webcheckin.register_guest": "Register guests",
  "app.webcheckin.hello": "Hello, ",
  "app.webcheckin.name_guest": "Name",
  "app.webcheckin.extra_fields": "Extra Fields",
  "app.webcheckin.type_guest": "Type",
  "app.webcheckin.melhous_btn": "VIEW MELHOUS",
  "staff.supply.no_signature": "No signature added",
  "app.webcheckin.contact": "Contact",
  "app.webcheckin.melhos.description":
    "With Melhous, you now have exclusive access to the best services and experiences for clients. Everything you need to know about us can be found ",
  "app.webcheckin.melhos.click": "here.",
  "app.webcheckin.melhos.exclusive": "App Exclusiva Para Clientes",
  "app.webcheckin.experiences.description_fr":
    "Explore the activities that we have prepared so that you can profit fully from your life.",
  "app.webcheckin.experiences.description":
    "Enjoy the best experiences we have prepared for you.",
  "app.webcheckin.experiences.melhous": "App Exclusive For Clients",
  "app.webcheckin.msg_ok": "Registration completed successfully.",
  "app.webcheckin.placeholder.description": "Write the description",
  "app.webcheckin.main_guest_description":
    "This record will be for the main guest of the booking.",
};

export default en;
